declare namespace $ {

	export class $mol_icon_power extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=power.view.tree.d.ts.map